import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";

export const SectionTitle = styled.h3`
    margin: 0;
    font-size: 25px;

    ${breakpoints.large} {
        font-size: 32px;
    }
`;
